<irb-inventory-grid id="irb-trade-details-grid"
  [style.width] = "'100%'"
  [style.height] = "'100%'"
  [gridHeight] = "gridHeight"
  [showSideBar] = "false"
  [gridOptions] = "gridOptions"
  (gridReady) = "onGridReady($event)"
  [frameworkComponents]="frameworkComponents"
  [masterDetail]="true"
></irb-inventory-grid>
<ng-template #viewBlockOrders>


  <div mat-dialog-title><b>Block Order Components</b><button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
  <mat-dialog-content>
    <div class="blockOrderTable">
      <div class="blockOrderHeading">Block Order</div>
      <table><tbody>
        <div class="block">
          <div class="left innerBlock">
            <div class="block">
              <div class="left">
                <div class="innerSubText"><strong>Block Acct#</strong></div>
                <span>{{blockOrder.accountNumber}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Symb</strong></div>
                <span>{{blockOrder.securitySymbol}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Shr Qty</strong></div>
                <span>{{blockOrder.quantity}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Trans Type</strong></div>
                <span>{{blockOrder.transactionType}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Order Amt</strong></div>
                <span>{{blockOrder.dollarAmount}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Order Type</strong></div>
                <span>{{blockOrder.orderType}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Price</strong></div>
                <span>{{blockOrder.price}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Exp Type</strong></div>
                <span>{{blockOrder.expirationType}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Exp Date</strong></div>
                <span>{{blockOrder.expirationDate}}</span>
              </div>
              <div class="left blokSubHeadingText">
                <div class="innerSubText"><strong>Not Held</strong></div>
                <span>{{blockOrder.ordIsNotHeld}}</span>
              </div>
            </div>
          </div>
        </div>
      </tbody>
    </table>
  </div>

  <div class="block"><strong>Allocation Details</strong></div>

  @if (openGrid) {
    <irb-inventory-grid
      [style.minHeight]="'300px'"
      [gridHeight]="'300px'"
      [showSideBar]="false"
      [gridOptions]="blockOrderGridOptions"
      [columnDefs]="blockOrderGridOptions.columnDefs"
      [rowData]="viewBlockOrder">
    </irb-inventory-grid>
  }

  * The number of shares that will be sold is the number of shares shown in the share quantity column. If the account holds additional shares due to a recent purchase or transfer, these shares will not be sold.

</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButtonViewBlock" mat-dialog-close class="btn-medium-primary">Close</button>
</mat-dialog-actions>
</ng-template>
